import { FormatColorTextIcon } from './FormatColorTextIcon';

/**
 * author: Google
 * id D28EF658-3CE7-4F5B-99B3-50F60F5B0BA0
 * name format-color-text
 * version: 1.7.12
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-color-text.svg
 * tags
 * - Text / Content / Format 
 * - Color 
 */
export const FormatColourTextIcon = FormatColorTextIcon;
export default FormatColourTextIcon